import defaultReducer from "./defaultReducer";

export default defaultReducer("INSTALL_HISTORY_MODAL", {
  grid: { data: [], rowDef: [], headerDef: [] },
  open: false,
});
